import styled from "@emotion/styled";
import { Box, Drawer as MuiDrawer } from "@mui/material";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";

const DRAWER_WIDTH = 180;

export const Drawer = styled(MuiDrawer)<{ paperWidth?: number }>`
  & > .MuiPaper-root {
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */

    &::-webkit-scrollbar {
      display: none;  /* Safari and Chrome */
    }

    ${({ theme, paperWidth }) => `
      box-sizing: border-box;
      margin: ${theme.spacing(Spacing.XXXL)};
      border-radius: ${theme.spacing(Radius.XXXL)};
      box-shadow: ${theme.shadows[2]};
      width: min(${theme.spacing(paperWidth ?? DRAWER_WIDTH)}, calc(100vw - ${theme.spacing(Spacing.XXXL * 2)}));
      height: calc(100vh - ${theme.spacing(Spacing.XXXL * 2)});
      transition: width 0.3s ease !important;
    `}
  }

  & > .MuiBackdrop-root {
    background-color: rgba(0, 0, 0, 0.25) !important;
  }
`;

export const DrawerContent = styled(Box)`
  height: 100%;
  overflow-y: scroll;
  margin-right: 4px;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0,0,0, 0.07);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: white;
  }
`;
